import { Stack, Typography } from "@mui/material";
import scan_frame from "../assets/svgGame/frame_bg.svg";
import GameButton from "./GameButton";
import { useTranslation } from "react-i18next";
import { STEPS } from "../consts";
import btnBg from '../assets/svgGame/button_bg.svg'
import questIcon from '../assets/svgGame/quest_icon.svg'
import riddleIcon from '../assets/svgGame/riddle_icon.svg'

function BtnBg({ children }) {
    return (<Stack
        direction="row"
        alignItems="center"
        justifyContent='space-between'
        height='2rem'
        padding='1rem'
        sx={{
            backgroundImage: `url(${btnBg})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            minWidth: '9rem',
            maxWidth: '15rem',
        }}
    // bgcolor={'blue'}
    >
        {children}
    </Stack>)
}

export default function Frame({ step, btn, children }) {
    const { t } = useTranslation();
    // const [btnStat, setBtnState] = useState(btn);

    // useEffect(() => {
    //     setBtnState(btn);
    // }, [btn?.title]);

    // return (null);
    return (
        <Stack
            sx={{
                backgroundImage: `url(${scan_frame})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                aspectRatio: '0.9/1.2',
                zIndex: 5,
                width: {
                    xs: '115vw',
                    sm: '80vw',
                    md: '50vw'
                },
                height: 'auto', // let height be determined by aspect ratio
                maxHeight: '85vh', // prevent it from getting too tall
                margin: 'auto',
            }}
        >
            <Stack
                // bgcolor={'#F4E1D5a0'}
                alignItems='center'
                // justifyContent={'space-between'}
                padding='3rem 2.2rem'
                // sx={{
                //     padding: {
                //         xs: '40px 30px',
                //         sm: '40px 30px',
                //         md: '40px 30px'
                //     },
                // }}
                height='100%'
            >
                {step === STEPS.RIDDLE || step === STEPS.QUESTION
                    ? <BtnBg>
                        <Typography
                            variant="h5"
                            width={'100%'}
                            textAlign={'center'}
                            mx={1}
                            fontSize={'1.7rem'}
                            fontWeight='bold'
                            color="#4A2615"
                            sx={{
                                // backgroundColor: 'yellow',
                                textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
                            }}
                        >
                            {step === STEPS.RIDDLE
                                ? t('RIDDLE')
                                : t('QUESTION')
                            }
                        </Typography>

                        <img
                            src={step === STEPS.RIDDLE
                                ? riddleIcon
                                : questIcon
                            }
                            alt="Title Icon"
                            style={{
                                // backgroundColor: 'aqua',
                                width: '40px',
                                height: '40px',
                                filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))'
                            }}
                        />
                    </BtnBg>
                    : <Stack height='4rem'></Stack>
                }

                <Stack
                    // bgcolor={'red'}
                    justifyContent='start'
                    padding={1}
                    width={{
                        xs: '60%',
                        sm: '45%',
                        md: '55%'
                    }}
                    height='100%'
                    maxWidth={250}
                    spacing={2}
                >
                    {children}
                </Stack>

                {btn
                    ? <BtnBg>
                        <GameButton
                            wide={btn?.wide}
                            hideIcon={btn?.hideIcon}
                            onClick={btn?.onClick}
                            title={step === STEPS.QUESTION
                                ? t('QUESTION')
                                : btn.title
                            }
                        />
                    </BtnBg>
                    : <Stack height='4rem'></Stack>
                }
            </Stack>
        </Stack >
    );
}
